import { getCustomProps } from '../forms'
import { getData } from '../get-table'
import { HttpService } from '../http.service'

const http = new HttpService()

export interface VacationRequest {
  payrollId: string
  employeeId: string
  journeyId: string
  days: number
  bonusDays: number
  startDate: Date
  endDate: Date
  amountPayedVacations: number
  payedVacations: number
  payedDate: Date
  coments: string
  origin: string
  attachment: string
  statusId: string
  isHistoric: boolean
}

export interface GetEndDate {
  employeeId: string
  days: string
  daysBonus: string
  startDate: string
}

export interface IReverseVacation {
  vacationRequestId: string
  observation: string
}

export async function getVacationRequests(
  offset: number,
  perPage: number,
  dataOrder: string,
  search: string = ''
): Promise<any> {
  // where's
  const where = ['employees.payroll_id=:payrollId']
  if (search) {
    where.push(
      `CONCAT(CONCAT(employees.code,' - ', employees.name),request_status.name) ILIKE '%${search}%'`
    )
  }
  // order by
  let modifier = []
  dataOrder !== ''
    ? (modifier = [`order by ${dataOrder[1]} ${dataOrder[0]}`])
    : (modifier = ['order by vacation_requests.updated_at desc'])
  // result
  const response: any = await getData({
    tables: ['pg_vacation_requests'],
    fields: [
      'vacation_requests.id',
      "CONCAT(employees.code,' - ', employees.name) as employee_name",
      'vacation_requests.normal_days_to_enjoy',
      'vacation_requests.bonus_days_to_enjoy',
      'vacation_requests.start_date_to_enjoy',
      'vacation_requests.end_date_to_enjoy',
      'request_status.name as status',
      `CONCAT(vacation_requests.locked_detail->>'locked') as locked`, 
      'vacation_requests.updated_at',
      'vacation_requests.detail',
      'vacation_requests.origin'
    ],
    join: [
      'INNER JOIN employees ON vacation_requests.employee_id = employees.id',
      'INNER JOIN request_status ON vacation_requests.status_id=request_status.id'
    ],
    where,
    modifier,
    options: {
      outputFormat: 'json',
      pagination: { offset, limit: perPage }
    }
  })
  return response
}

export async function getVacationRequest(id: string): Promise<VacationRequest> {
  const data = await getData<any>({
    tables: ['pg_vacation_requests'],
    fields: [
      'vacation_requests.id',
      'payroll_id as payrollId',
      'employee_id as employeeId',
      'journey_id as journeyId',
      'normal_days_to_enjoy as days',
      'bonus_days_to_enjoy as bonusDays',
      "TO_CHAR(start_date_to_enjoy,'yyyy-mm-dd') as startDate",
      "TO_CHAR(end_date_to_enjoy,'yyyy-mm-dd') as endDate",
      'payed_vacations as payedVacations',
      'amount_payed_vacations as amountPayedVacations',
      "TO_CHAR(payed_date,'yyyy-mm-dd') as payedDate",
      'coments',
      'attachment',
      'status_id as statusId',
      'custom_fields as custom'
    ],
    where: [`vacation_requests.id = '${id}'`],
    options: {
      outputFormat: 'json',
      pagination: { offset: 0, limit: 10 }
    }
  })
  return data[0].results[0]
}

export async function createVacationRequest(
  data: VacationRequest
): Promise<boolean> {
  const response: any = await http.post('vacation/request', {
    payrollId: data.payrollId,
    employeeId: data.employeeId,
    journeyId: data.journeyId,
    days: data.days,
    bonusDays: data.bonusDays,
    startDate: data.startDate,
    endDate: data.endDate,
    payedVacations: data.payedVacations,
    amountPayedVacations: data.amountPayedVacations,
    payedDate: data.payedDate,
    coments: data.coments,
    attachment: data.attachment,
    statusId: data.statusId,
    origin: 'APS_UI',
    isHistoric: data.isHistoric,
    customFields: {
      ...getCustomProps(data)
    }
  })

  if (response?.data?.data?.error) {
    return false
  }
  return true
}

export async function updateVacationRequest(
  data: VacationRequest,
  id: string
): Promise<boolean> {
  const response: any = await http.put('vacation/request/' + id, {
    payrollId: data.payrollId,
    employeeId: data.employeeId,
    journeyId: data.journeyId,
    days: data.days,
    bonusDays: data.bonusDays,
    startDate: data.startDate,
    endDate: data.endDate,
    payedVacations: data.payedVacations,
    amountPayedVacations: data.amountPayedVacations,
    payedDate: data.payedDate,
    coments: data.coments,
    attachment: data.attachment,
    statusId: data.statusId,
    origin: 'APS_UI',
    isHistoric: data.isHistoric,
    customFields: {
      ...getCustomProps(data)
    }
  })

  if (response?.data?.data?.error) {
    return false
  }
  return true
}

export async function getEndDate(data: GetEndDate): Promise<string> {
  const response: any = await http.post('vacation/request/end-date', {
    employeeId: data.employeeId,
    days: data.days,
    daysBonus: data.daysBonus,
    startDate: data.startDate
  })

  if (response?.data?.data?.error) {
    return response?.data?.data?.error
  }
  return response?.data?.endDate
}

export async function deleteVacationRequest(id: string): Promise<boolean> {
  const response: any = await http.delete('vacation/request/' + id)

  if (response?.data?.data?.error) {
    return false
  }
  return true
}

export async function getJourneyEmployee(id: string): Promise<any> {
  const response: any = await getData({
    tables: ['pg_employees'],
    fields: ['journey_id'],

    where: [`id='${id}'`],

    options: {
      outputFormat: 'json'
    }
  })

  return response[0].results[0].journey_id
}

export async function reverseVacation(data: IReverseVacation): Promise<any> {
  const response: any = await http.post(
    'vacation/request/reverse/' + data.vacationRequestId,
    {
      observation: data.observation
    }
  )

  if (response?.data?.data?.error) {
    return response?.data?.data?.error
  }

  return response?.data
}

export async function canceledVacation(data: IReverseVacation): Promise<any> {
  const response: any = await http.post(
    'vacation/request/canceled/' + data.vacationRequestId,
    {
      reason: data.observation
    }
  )

  if (response?.data?.data?.error) {
    return response?.data?.data?.error
  }

  return response?.data
}